import { useLanguage, t } from "../../../i18n";
import React, { useState } from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "../../../components/layout/Header/Header";
import MobileOffcanvasNav from "../../../components/layout/MobileOffcanvasNav/MobileOffcanvasNav";
import Footer from "../../../components/layout/Footer/Footer";
import ROUTES from "../../../config/routes";
import "./TermsConditions.css";
export default function TermsConditions() {
  useLanguage();
  const [showMobileNav, setShowMobileNav] = useState(false);
  const navigate = useNavigate();
  return <div className="bb-public-page bb-terms-page">
      <Header onMenuClick={() => setShowMobileNav(true)} />

      <MobileOffcanvasNav show={showMobileNav} onHide={() => setShowMobileNav(false)} />


      <main className="bb-terms-page__main">
        <Container>
          <section className="bb-terms-page__hero">
            <div className="bb-terms-page__hero-content">
              <span className="bb-terms-page__eyebrow">{t("Legal")}</span>
              <h1 className="bb-terms-page__title">{t("Terms & Conditions")}</h1>
              <p className="bb-terms-page__subtitle">{t("These Terms & Conditions govern access to and use of the BaytBuddy platform and explain the rules, responsibilities, and limitations applicable to all users of the service.")}



              </p>

              <div className="bb-terms-page__hero-actions">
                <Button variant="outline-primary" className="bb-brand-btn-outline" onClick={() => navigate(ROUTES.ROOT)}>{t("Back to Home")}


                </Button>
              </div>
            </div>
          </section>

          <section className="bb-terms-page__meta-card">
            <p>
              <strong>{t("Last updated:")}</strong>{t(" 19 April 2026")}
            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("1. Acceptance of Terms")}</h2>
            <p>{t("By accessing or using BaytBuddy (\"Platform\", \"we\", \"our\", or \"us\"), you agree to comply with and be bound by these Terms & Conditions.")}



            </p>
            <p>{t("If you do not agree with these Terms, you must not use the Platform.")}


            </p>
            <p>{t("By creating an account, browsing listings, posting content, or communicating with other users, you confirm that you have read, understood, and accepted these Terms.")}



            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("2. About BaytBuddy")}</h2>
            <p>{t("BaytBuddy is a digital platform that connects individuals seeking shared accommodation, roommates, or co-living opportunities within the Kingdom of Saudi Arabia.")}



            </p>
            <p>{t("The Platform allows users to:")}</p>
            <ul>
              <li>{t("create personal profiles")}</li>
              <li>{t("search for roommates")}</li>
              <li>{t("publish room or shared accommodation listings")}</li>
              <li>{t("communicate with other users")}</li>
              <li>{t("explore shared housing opportunities")}</li>
              <li>{t("discover compatible co-living arrangements")}</li>
            </ul>
            <p>{t("BaytBuddy does not own, lease, manage, control, or inspect any properties listed on the Platform.")}


            </p>
            <p>{t("BaytBuddy acts solely as a technology platform that facilitates connections between users.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("3. Eligibility")}</h2>
            <p>{t("To use BaytBuddy, you must:")}</p>
            <ul>
              <li>{t("be at least 18 years old")}</li>
              <li>{t("have legal capacity to enter agreements")}</li>
              <li>{t("provide accurate and truthful information")}</li>
              <li>{t("comply with all applicable laws and regulations in Saudi Arabia")}

              </li>
            </ul>
            <p>{t("BaytBuddy reserves the right to suspend or terminate accounts that provide false or misleading information.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("4. User Accounts")}</h2>
            <p>{t("Certain features require account registration.")}</p>
            <p>{t("Users are responsible for:")}</p>
            <ul>
              <li>{t("maintaining confidentiality of login credentials")}</li>
              <li>{t("ensuring account information is accurate")}</li>
              <li>{t("updating their information when necessary")}</li>
              <li>{t("restricting unauthorized access to their account")}</li>
            </ul>
            <p>{t("Users agree not to:")}</p>
            <ul>
              <li>{t("impersonate another individual")}</li>
              <li>{t("create fake accounts")}</li>
              <li>{t("provide misleading information")}</li>
              <li>{t("use the platform for fraudulent purposes")}</li>
              <li>{t("attempt to bypass platform safeguards")}</li>
            </ul>
            <p>{t("BaytBuddy reserves the right to suspend or terminate accounts that violate these Terms.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("5. Identity and Profile Information")}</h2>
            <p>{t("BaytBuddy may request certain profile information to improve trust between users and reduce fraudulent activity.")}


            </p>
            <p>{t("Users may choose to provide personal or profile-related information to enhance their visibility and credibility on the Platform.")}



            </p>
            <p>{t("BaytBuddy does not guarantee the accuracy, authenticity, or reliability of any information provided by users.")}


            </p>
            <p>{t("Users remain fully responsible for verifying the identity, credibility, and suitability of any person they interact with through the Platform.")}



            </p>
            <p>{t("BaytBuddy reserves the right to introduce additional account verification measures at its discretion.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("6. Listings and User Content")}</h2>
            <p>{t("Users may publish listings for rooms, shared apartments, bedspaces, or co-living opportunities.")}


            </p>
            <p>{t("Users are solely responsible for:")}</p>
            <ul>
              <li>{t("the accuracy of listing information")}</li>
              <li>{t("photos uploaded")}</li>
              <li>{t("pricing details")}</li>
              <li>{t("property descriptions")}</li>
              <li>{t("ensuring they have the right to publish the listing")}</li>
              <li>{t("communications with other users")}</li>
            </ul>
            <p>{t("Users must not post:")}</p>
            <ul>
              <li>{t("false or misleading listings")}</li>
              <li>{t("duplicate listings")}</li>
              <li>{t("discriminatory content")}</li>
              <li>{t("offensive content")}</li>
              <li>{t("illegal content")}</li>
              <li>{t("listings without proper authorization")}</li>
              <li>{t("misleading property information")}</li>
            </ul>
            <p>{t("BaytBuddy reserves the right to remove or modify listings that violate these Terms.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("7. Roommates and Shared Housing")}</h2>
            <p>{t("BaytBuddy provides a platform that enables users to connect regarding shared housing opportunities.")}


            </p>
            <p>{t("BaytBuddy is not a real estate broker, agent, landlord, or property manager.")}


            </p>
            <p>{t("BaytBuddy is not a party to any agreement between users, including but not limited to:")}


            </p>
            <ul>
              <li>{t("rental agreements")}</li>
              <li>{t("roommate agreements")}</li>
              <li>{t("cost-sharing agreements")}</li>
              <li>{t("housing arrangements")}</li>
              <li>{t("occupancy agreements")}</li>
            </ul>
            <p>{t("Users are solely responsible for:")}</p>
            <ul>
              <li>{t("verifying property information")}</li>
              <li>{t("confirming permissions where applicable")}</li>
              <li>{t("ensuring compliance with applicable laws")}</li>
              <li>{t("reviewing any agreements carefully")}</li>
              <li>{t("assessing compatibility with other users")}</li>
            </ul>
            <p>{t("BaytBuddy does not guarantee:")}</p>
            <ul>
              <li>{t("property availability")}</li>
              <li>{t("suitability of roommates")}</li>
              <li>{t("accuracy of listings")}</li>
              <li>{t("compatibility between users")}</li>
              <li>{t("success of any housing arrangement")}</li>
            </ul>
            <p>{t("All decisions made through the Platform are the responsibility of the user.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("8. User Communication")}</h2>
            <p>{t("The Platform may provide tools that allow users to communicate with one another.")}


            </p>
            <p>{t("BaytBuddy does not control, monitor in real time, or guarantee the accuracy of communications between users.")}


            </p>
            <p>{t("Users are responsible for exercising judgment and caution when communicating with other users.")}


            </p>
            <p>{t("BaytBuddy reserves the right to review reported communications if required for safety or compliance purposes.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("9. Payments and Fees")}</h2>
            <p>{t("Certain features of the Platform may be subject to fees.")}</p>
            <p>{t("Any applicable fees will be clearly presented before payment is made.")}


            </p>
            <p>{t("Payments may include services such as:")}</p>
            <ul>
              <li>{t("listing visibility upgrades")}</li>
              <li>{t("premium features")}</li>
              <li>{t("subscriptions")}</li>
              <li>{t("promotional services")}</li>
            </ul>
            <p>{t("BaytBuddy reserves the right to modify pricing at any time.")}</p>
            <p>{t("Payments may be processed through third-party service providers.")}

            </p>
            <p>{t("BaytBuddy is not responsible for disruptions caused by third-party payment providers.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("10. User Safety Guidelines")}</h2>
            <p>{t("User safety is important; however, BaytBuddy cannot guarantee the conduct of any user.")}


            </p>
            <p>{t("Users agree to follow reasonable safety precautions when interacting with others, including:")}


            </p>
            <ul>
              <li>{t("verifying information independently")}</li>
              <li>{t("communicating responsibly")}</li>
              <li>{t("avoiding sharing sensitive personal information prematurely")}</li>
              <li>{t("exercising caution when meeting individuals")}</li>
              <li>{t("reviewing any agreements carefully")}</li>
              <li>{t("reporting suspicious activity")}</li>
            </ul>
            <p>{t("Users must NOT:")}</p>
            <ul>
              <li>{t("harass or threaten other users")}</li>
              <li>{t("engage in fraudulent behavior")}</li>
              <li>{t("request unlawful payments")}</li>
              <li>{t("impersonate others")}</li>
              <li>{t("misuse personal information")}</li>
              <li>{t("upload harmful or illegal content")}</li>
              <li>{t("attempt scams")}</li>
              <li>{t("pressure other users into unsafe arrangements")}</li>
            </ul>
            <p>{t("BaytBuddy reserves the right to suspend accounts that pose safety risks.")}


            </p>
            <p>{t("Users are encouraged to report suspicious activity.")}</p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("11. Platform Availability")}</h2>
            <p>{t("BaytBuddy strives to maintain reliable platform access but does not guarantee uninterrupted service.")}


            </p>
            <p>{t("We may:")}</p>
            <ul>
              <li>{t("modify features")}</li>
              <li>{t("update functionality")}</li>
              <li>{t("perform maintenance")}</li>
              <li>{t("improve performance")}</li>
              <li>{t("introduce or remove features")}</li>
            </ul>
            <p>{t("Temporary interruptions may occur.")}</p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("12. Intellectual Property")}</h2>
            <p>{t("All platform content including:")}</p>
            <ul>
              <li>{t("logos")}</li>
              <li>{t("design")}</li>
              <li>{t("structure")}</li>
              <li>{t("text")}</li>
              <li>{t("graphics")}</li>
              <li>{t("software")}</li>
              <li>{t("features")}</li>
            </ul>
            <p>{t("are the intellectual property of BaytBuddy.")}</p>
            <p>{t("Users may not:")}</p>
            <ul>
              <li>{t("copy platform structure")}</li>
              <li>{t("reproduce content")}</li>
              <li>{t("extract data without permission")}</li>
              <li>{t("reverse engineer the platform")}</li>
              <li>{t("use branding without authorization")}</li>
            </ul>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("13. Prohibited Activities")}</h2>
            <p>{t("Users may not use the Platform to:")}</p>
            <ul>
              <li>{t("violate applicable laws")}</li>
              <li>{t("publish misleading information")}</li>
              <li>{t("distribute spam")}</li>
              <li>{t("scrape or extract user data")}</li>
              <li>{t("conduct unauthorized advertising")}</li>
              <li>{t("upload harmful software")}</li>
              <li>{t("attempt unauthorized access")}</li>
              <li>{t("interfere with platform functionality")}</li>
              <li>{t("misuse platform features")}</li>
            </ul>
            <p>{t("BaytBuddy reserves the right to restrict access where misuse is detected.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("14. Limitation of Liability")}</h2>
            <p>{t("BaytBuddy is not responsible for:")}</p>
            <ul>
              <li>{t("disputes between users")}</li>
              <li>{t("roommate disagreements")}</li>
              <li>{t("rental disputes")}</li>
              <li>{t("inaccurate listings")}</li>
              <li>{t("user behavior")}</li>
              <li>{t("property condition")}</li>
              <li>{t("compatibility outcomes")}</li>
              <li>{t("financial losses")}</li>
              <li>{t("agreements made between users")}</li>
            </ul>
            <p>{t("The Platform is provided on an \"as is\" basis without warranties of any kind.")}


            </p>
            <p>{t("Users accept full responsibility for decisions made using the Platform.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("15. Account Suspension or Termination")}</h2>
            <p>{t("BaytBuddy reserves the right to suspend or terminate accounts that:")}</p>
            <ul>
              <li>{t("violate these Terms")}</li>
              <li>{t("provide false information")}</li>
              <li>{t("engage in harmful conduct")}</li>
              <li>{t("misuse the Platform")}</li>
              <li>{t("create risk for other users")}</li>
              <li>{t("attempt fraudulent activity")}</li>
            </ul>
            <p>{t("BaytBuddy may remove content or restrict access without prior notice where necessary.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("16. Privacy")}</h2>
            <p>{t("Use of the Platform is also governed by the Privacy Policy.")}</p>
            <p>{t("The Privacy Policy explains how personal data is collected, used, and protected.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("17. Third-Party Services")}</h2>
            <p>{t("The Platform may rely on external service providers to support functionality, security, analytics, or communication features.")}


            </p>
            <p>{t("BaytBuddy is not responsible for the performance or availability of third-party services.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("18. Future Features")}</h2>
            <p>{t("BaytBuddy may introduce new features, tools, integrations, or services at any time to improve the Platform.")}


            </p>
            <p>{t("Such features may include functionality related to identity confirmation, communication tools, compatibility tools, listing enhancements, or other services designed to improve user experience.")}




            </p>
            <p>{t("BaytBuddy reserves the right to modify, add, or discontinue features at its discretion.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("19. Changes to Terms")}</h2>
            <p>{t("BaytBuddy may update these Terms at any time.")}</p>
            <p>{t("Updated versions will be published on the Platform.")}</p>
            <p>{t("Continued use of the Platform indicates acceptance of the revised Terms.")}


            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("20. Governing Law")}</h2>
            <p>{t("These Terms are governed by the laws of the Kingdom of Saudi Arabia.")}


            </p>
            <p>{t("Any disputes shall be subject to the jurisdiction of Saudi courts.")}

            </p>
          </section>

          <section className="bb-terms-page__section">
            <h2>{t("21. Contact Information")}</h2>
            <p>{t("For inquiries regarding these Terms:")}</p>
            <p>
              <strong>{t("Email: info@baytbuddy.com")}</strong>
            </p>
          </section>
        </Container>
      </main>

      <Footer />
    </div>;
}
